//Dependencies
import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
//Pages
import LoginFLow from './Pages/LoginFlow';
import AdminDashboard from './Pages/AdminDashboard';
import ReadingPortalUsers from './Pages/ReadingPortalUsers';
import WorksheetsUsers from './Pages/WorksheetsUsers';
import MoonrockAnalytics from './Pages/MoonrockAnalytics';
import MoonrockGameAssets from './Pages/MoonrockGameAssets';
//Components
import ProtectedRoute from './Components/ProtectedRoute';
import AppShell from './Components/Layout/AppShell';
//Context
import { UserContextProvider } from './Components/Context/UserContext';

function App() {
  return (
    <main className="App">
      <UserContextProvider>
        <Switch>
          <Route
            path="/"
            exact
            render={(props) => {
              return <LoginFLow routerProps={props} />;
            }}
          />
          <Route path="/admin">
            <AppShell>
                <Switch>
                  <ProtectedRoute path="/admin" exact={true} securityGroup={'admin_portal'} component={AdminDashboard} />
                  <ProtectedRoute
                    exact={true}
                    path="/admin/readingPortalUsers"
                    securityGroup={'admin_portal'}
                    component={ReadingPortalUsers}
                  />
                  <ProtectedRoute
                    exact={true}
                    path="/admin/worksheetsUsers"
                    securityGroup={'admin_portal'}
                    component={WorksheetsUsers}
                  />
                  <ProtectedRoute
                    exact={true}
                    path="/admin/moonrock/assets"
                    securityGroup={'admin_portal'}
                    component={MoonrockGameAssets}
                  />
                  <ProtectedRoute
                    exact={true}
                    path="/admin/moonrock"
                    securityGroup={'admin_portal'}
                    component={MoonrockAnalytics}
                  />
                  <Redirect to="/admin" />
                </Switch>
            </AppShell>
          </Route>
          <Redirect to="/" />
        </Switch>
      </UserContextProvider>
    </main>
  );
}

export default App;
